// ABOUTME: Utility functions for calendar date range calculations and formatting
// ABOUTME: Handles complete week calculations and API date formatting for heart calendar display

export interface DateRange {
  startDate: Date;
  endDate: Date;
}

export function getCompleteWeeksDateRange(today: Date): DateRange {
  // Calculate 2 weeks ago
  const twoWeeksAgo = new Date(today);
  twoWeeksAgo.setDate(today.getDate() - 14);
  
  // Calculate 1 week from now
  const oneWeekFromNow = new Date(today);
  oneWeekFromNow.setDate(today.getDate() + 7);
  
  // Find Sunday of the week containing 2-weeks-ago
  const startDate = new Date(twoWeeksAgo);
  const daysToSubtract = startDate.getDay(); // 0 = Sunday, 1 = Monday, etc.
  startDate.setDate(startDate.getDate() - daysToSubtract);
  
  // Find Saturday of the week containing 1-week-from-now
  const endDate = new Date(oneWeekFromNow);
  const daysToAdd = 6 - endDate.getDay(); // 6 = Saturday
  endDate.setDate(endDate.getDate() + daysToAdd);
  
  return { startDate, endDate };
}

export function formatDateForAPI(date: Date): string {
  // Use local date components to avoid timezone issues
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}

export function getDayOfWeekIndex(date: Date): number {
  return date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
}

/**
 * Get the date range for the current week (Sunday to Saturday) containing `today`
 */
export function getCurrentWeekDateRange(today: Date): DateRange {
  const startDate = new Date(today);
  startDate.setDate(today.getDate() - today.getDay()); // back to Sunday
  startDate.setHours(0, 0, 0, 0);

  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6); // forward to Saturday
  endDate.setHours(23, 59, 59, 999);

  return { startDate, endDate };
}